import { TimePicker } from '@formily/antd';
import { createSchemaComponent } from '../../shared';
export default createSchemaComponent({
    componentName: 'TimePicker',
    component: TimePicker,
});
